// Inline style objects for the Timeline case modal and its sections. Split out
// of TimelineCaseModal.js only to keep that file under the 500-line house
// limit — this is the same `st` object it always had, plus the room-summary
// strip. No CSS modules, per house rules.
import tokens from "../../theme/tokens";

const { color, font, radius } = tokens;

const st = {
  body: { display: "flex", flexDirection: "column", gap: 16 },
  section: { display: "flex", flexDirection: "column", gap: 8, paddingBottom: 12, borderBottom: `1px solid ${color.border.default}` },
  sectionTitle: { fontSize: font.size.label, fontWeight: font.weight.bold, color: color.text.muted, textTransform: "uppercase", letterSpacing: ".5px" },
  timesRow: { display: "flex", alignItems: "flex-end", gap: 10, flexWrap: "wrap" },
  row: { display: "flex", alignItems: "flex-end", gap: 10, flexWrap: "wrap" },
  field: { display: "flex", flexDirection: "column", gap: 4, fontSize: 12, fontWeight: font.weight.semibold, color: color.text.secondary },
  select: { padding: "8px 10px", borderRadius: radius.sm, border: `1px solid ${color.border.default}`, fontSize: 13, fontFamily: "inherit", background: "#fff", color: color.text.primary, minWidth: 110 },
  slot: { display: "flex", flexDirection: "column", gap: 8, background: color.surface.raised, borderRadius: radius.sm, padding: "10px 12px" },
  slotHead: { display: "flex", alignItems: "baseline", gap: 8 },
  slotKind: { fontSize: 11, fontWeight: font.weight.bold, color: color.text.muted, textTransform: "uppercase", letterSpacing: ".5px" },
  slotName: { fontSize: font.size.body, fontWeight: font.weight.semibold, color: color.text.primary },
  dispoRow: { display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" },
  dispoLabel: { fontSize: 12, color: color.text.secondary },
  dispoBtn: { background: "#fff", border: `1px solid ${color.border.default}`, color: color.text.secondary, borderRadius: radius.full, padding: "4px 12px", fontSize: 12, fontWeight: font.weight.semibold, cursor: "pointer", fontFamily: "inherit" },
  dispoBtnOn: { background: "#1e40af14", borderColor: color.accent.primary, color: color.accent.primary },
  stageNote: { margin: "6px 0 0", fontSize: 11.5, lineHeight: 1.4, color: color.text.muted },
  applyRow: { display: "flex", justifyContent: "flex-end", gap: 8, flexWrap: "wrap" },

  // ── WHO IS IN THIS ROOM ────────────────────────────────────────────────
  // A read-only strip at the very top. It exists because a second CRNA pushes
  // the supervising doctor's section further down the dialog than it has ever
  // been, and the surgeon and the supervising doctor are the two facts an
  // anesthesiologist checks FIRST when they open a room.
  people: { display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: 10 },
  personCell: { display: "flex", flexDirection: "column", gap: 2, minWidth: 0 },
  personKind: { fontSize: 10.5, fontWeight: font.weight.bold, color: color.text.muted, textTransform: "uppercase", letterSpacing: ".5px" },
  personName: { fontSize: font.size.body, fontWeight: font.weight.semibold, color: color.text.primary, overflowWrap: "anywhere" },
  personNone: { fontSize: font.size.body, fontWeight: font.weight.semibold, color: color.text.muted },
};

export default st;
